import Dropzone, { Accept } from 'react-dropzone'

import { Box, List, Text, dimensions } from '@factorialco/deprecated-design-system'
import clouds from 'assets/images/import-clouds.svg'

import { Option } from 'modules/layout/components/ResponsivePage/_PageHeader/_Actions'

import { FileDropItem } from '../FileDropItem'

export interface FileWithStatus<T> {
  file: File
  options?: Option[]
  result?: T
  status: 'waiting' | 'success' | 'error' | 'processing'
}

export interface FileWithStatusDropzoneProps<T> {
  filesWithStatus: FileWithStatus<T>[]
  onDrop: (files: File[]) => void
  onItemRemove?: (filwWithStatus: FileWithStatus<T>) => void
  accept?: Accept
  children?: React.ReactNode
  multiple?: boolean
}

export function FileWithStatusDropzone<T>({
  filesWithStatus,
  onDrop,
  onItemRemove,
  accept,
  children,
  multiple = true,
}: FileWithStatusDropzoneProps<T>) {
  const disabled = filesWithStatus && filesWithStatus.length > 0 && !multiple

  return (
    <Box flexDirection="column" gap={'s4'}>
      <Dropzone disabled={disabled} onDrop={onDrop} multiple={multiple} accept={accept}>
        {({ getRootProps, getInputProps, isDragActive }) => (
          <div {...getRootProps()}>
            <Box
              background={isDragActive ? 'viridian100' : 'grey000White'}
              padding="s32"
              cursor="pointer"
              flexDirection="column"
              alignItems="center"
              borderRadius={{ all: 'abs006' }}
              border={{
                all: {
                  width: 's2',
                  style: 'dashed',
                  color: 'grey400',
                },
              }}
              style={{ cursor: disabled ? 'no-drop' : undefined }}
            >
              <input data-testid="dropzone-input" {...getInputProps()} />
              <Box textAlign="center">
                <Box alignItems="center">
                  <Box paddingBottom="s6" style={{ opacity: disabled ? '0.4' : undefined }}>
                    <img height={dimensions.s64} src={clouds} />
                  </Box>
                  <Text.Normal>{children}</Text.Normal>
                </Box>
              </Box>
            </Box>
          </div>
        )}
      </Dropzone>
      {filesWithStatus && filesWithStatus.length > 0 && (
        <Box paddingTop={'s24'}>
          <List>
            {filesWithStatus.map((fileWithStatus, index) => (
              <FileDropItem
                key={index}
                fileName={fileWithStatus.file.name}
                status={fileWithStatus.status}
                options={fileWithStatus.options}
                onRemove={onItemRemove ? () => onItemRemove(fileWithStatus) : undefined}
              />
            ))}
          </List>
        </Box>
      )}
    </Box>
  )
}
